import { Usuario } from './usuario';
import { GrauEscolaridade } from './grau-escolaridade';
import { Raca } from './raca';
import { Nacionalidade } from './nacionalidade';
import { Localidade } from './localidade';
import { ServidorTodos } from './servidor-todos';
import { ServidorSrh2 } from './servidor-srh2';

export class Servidor {
  idServidor: number = null;
  dsNomeServidor: string = null;
  dsNomeSocial: string = null;
  lotacao: Localidade = null;
  nrCpf: string = null;
  dtNascimento: Date = null;
  txtSexo: string = null;
  nacionalidade: Nacionalidade = null;
  grauEscolaridade: GrauEscolaridade = null;
  raca: Raca = null;
  dsEmail: string = null;
  nrMatricula: string = null;
  nrMatriculaAtual: string = null;

  usuario: Usuario = null;
  servidorTodos: ServidorTodos = null;
  servidorSrh2: ServidorSrh2 = null;

  constructor(data?) {
    if (data) {
      this.idServidor = data.idServidor ? data.idServidor : null;
      this.dsNomeServidor = data.dsNomeServidor ? data.dsNomeServidor : null;
      this.dsNomeSocial = data.dsNomeSocial ? data.dsNomeSocial : null;
      this.lotacao = data.lotacao ? new Localidade(data.lotacao) : null;
      this.nrCpf = data.nrCpf ? data.nrCpf : null;
      this.dtNascimento = data.dtNascimento ? data.dtNascimento : null;
      this.txtSexo = data.txtSexo ? data.txtSexo : null;
      this.nacionalidade = data.nacionalidade
        ? new Nacionalidade(data.nacionalidade)
        : null;
      this.grauEscolaridade = data.grauEscolaridade
        ? new GrauEscolaridade(data.grauEscolaridade)
        : null;
      this.raca = data.raca ? new Raca(data.raca) : null;
      this.dsEmail = data.dsEmail ? data.dsEmail : null;
      this.nrMatricula = data.nrMatricula ? data.nrMatricula : null;
      this.nrMatriculaAtual = data.nrMatriculaAtual
        ? data.nrMatriculaAtual
        : null;
      this.usuario = new Usuario(data.usuario)
        ? new Usuario(data.usuario)
        : null;
      this.servidorTodos = data.servidorTodos
        ? new ServidorTodos(data.servidorTodos)
        : null;
      this.servidorSrh2 = data.servidorSrh2
        ? new ServidorSrh2(data.servidorSrh2)
        : null;
    }
  }

  getTeste() {
    return 'SERVIDOR: ' + this.idServidor + ' - ' + this.dsNomeSocial;
  }

  getCpf() {
    return this.nrCpf
      ? this.nrCpf
      : this.servidorTodos
      ? this.servidorTodos.nrCPF
      : null;
  }
}
